import { useState, useEffect, useCallback } from 'react'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import { getDataMapFromCommonResponse, isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'

export const useCommunicationLogs = (patientId, bookedEventId, enabled = true) => {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [totalElements, setTotalElements] = useState(0)
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(20)

  const fetchLogs = useCallback(async () => {
    if (!enabled || !patientId) {
      setLogs([])
      return
    }

    setLoading(true)
    setError(null)

    try {
      const params = {
        patientId,
        ...(bookedEventId && { bookedEventId }),
        page,
        size,
        sort: 'sentAt,desc',
      }

      const response = await getSPDataWithParams('/api/secure/cc/support/communication-logs', params)

      if (response.status === 200 && isCommonResponseSuccessfulV2(response)) {
        const data = getDataMapFromCommonResponse(response)?.['communication-logs']
        setLogs(data?.content || [])
        setTotalElements(data?.totalElements || 0)
        setPage(data?.pageable?.pageNumber || 0)
      } else {
        setError('Failed to fetch communication logs')
        setLogs([])
      }
    } catch (err) {
      console.error('Error fetching communication logs:', err)
      setError('An error occurred while fetching communication logs')
      setLogs([])
    } finally {
      setLoading(false)
    }
  }, [patientId, bookedEventId, page, size, enabled])

  useEffect(() => {
    fetchLogs()
  }, [fetchLogs])

  return {
    logs,
    loading,
    error,
    totalElements,
    page,
    size,
    setPage,
    refreshLogs: fetchLogs,
  }
}


